import { createApp } from 'vue';
import MdToPdfConverter from '@/Components/MdToPdfConverter.vue';
import '@styles/app.css';

createApp(MdToPdfConverter).mount('#md-to-pdf-converter');
